export default {
  coversBaseUrl: 'https://eltigre.imgix.net/',
  bundleId: 'com.ebooksPatagonia.Patagonia',
  appName: 'Ebooks Patagonia',
  baseUrl: 'https://us-central1-patagonia-51e02.cloudfunctions.net/patagonia/'
};



// WEBPACK FOOTER //
// ./src/config/AppConfig.js